import { RequestSummaryLegend } from '@reveni-io/reveni-ui'

import CancellationsPortalMessage from './CancellationsPortalMessage/CancellationsPortalMessage'
import useRefundMessage from './hooks/useRefundMessage'

const RefundMessage = ({ refundType, orderAmount, issueRefundAtStatus, isCancellationsPortal }) => {
  const { title, description, instant, methodName, MethodIcon } = useRefundMessage(refundType)

  if (isCancellationsPortal) {
    return (
      <CancellationsPortalMessage
        refundType={refundType}
        orderAmount={orderAmount}
        issueRefundAtStatus={issueRefundAtStatus}
      />
    )
  }

  return (
    <RequestSummaryLegend
      title={title}
      description={description}
      instant={instant}
      methodName={methodName}
      methodIcon={MethodIcon && <MethodIcon size={20} />}
    />
  )
}

export default RefundMessage
